import React, { Component } from 'react';

import { bool, string } from 'prop-types';
import uuid from 'uuid/v4';

import { eventListener, expression } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, defaultClasses } from '@philips-emr/tws-utils';

class RadioButton extends Component {

  static propTypes = {
    checked: bool,
    enabled: bool,
    label: expression,
    name: string,
    onBlur: eventListener,
    onChange: eventListener,
    onFocus: eventListener,
    readOnly: bool,
    uuid: string,
    value: string,
  };

  static defaultProps = {
    enabled: true,
  };

  onChange = (event) => {
    const { onChange } = this.props;

    onChange && onChange({ value: event.target.value });
  };

  render() {
    const { name, value, enabled, label, checked, onBlur, onFocus, readOnly } = this.props;
    const id = uuid();

    const rootClasses = {
      'c-radio-button': true,
      ...defaultClasses(this.props),
    };

    return (
      <div className={classNames(rootClasses)}>
        <input
          className="c-radio-button__input"
          type="radio"
          id={id}
          name={name}
          value={value}
          disabled={readOnly || !enabled}
          checked={checked}
          onChange={this.onChange}
          onBlur={() => onBlur()}
          onFocus={() => onFocus()} />

        <label className="c-radio-button__label" htmlFor={id}>{msg(label)}</label>
      </div>
    );
  }
}

export default RadioButton;

